window.applySlider = function(){
  document.querySelectorAll('.product-item').forEach(productItem => {
    if(!productItem.classList.contains("event-added")){
      productItem.classList.add("event-added");
      const productMedia = productItem.querySelector('.product-item__media');
      const prevButton = productItem.querySelector('.image-page-button--previous');
      const nextButton = productItem.querySelector('.image-page-button--next');
  
      let startX = 0;
      let startY = 0;
  
      // Swipe functionality
      if(window.image_stack_slider_mobile == "slider"){
        productMedia.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        });
    
        productMedia.addEventListener('touchend', (e) => {
          const endX = e.changedTouches[0].clientX;
          const endY = e.changedTouches[0].clientY;
          
          // Check if the swipe was more horizontal than vertical
          if (Math.abs(endX - startX) > Math.abs(endY - startY)) {
            const swipeDirection = startX > endX ? 'left' : 'right';
            updateImages(swipeDirection, productMedia);
          }
        });
      }
  
      // Click functionality for Next and Previous buttons
      if(window.image_stack_slider_desktop == "slider"){
        if (prevButton) {
          prevButton.addEventListener('click', () => updateImages('right', productMedia));
        }
    
        if (nextButton) {
          nextButton.addEventListener('click', () => updateImages('left', productMedia));
        }
      }
  
      // Update images based on direction
      function updateImages(direction, mediaElement) {
        const images = Array.from(mediaElement.querySelectorAll('.product-item__image'));
        const oneIndex = images.findIndex(img => img.classList.contains('product-item__image--one'));
        const twoIndex = images.findIndex(img => img.classList.contains('product-item__image--two'));
  
        let newOneIndex, newTwoIndex;
        if (direction === 'left') {
          newOneIndex = (oneIndex + 1) % images.length;
          newTwoIndex = (newOneIndex + 1) % images.length;
        } else {
          newOneIndex = (oneIndex - 1 + images.length) % images.length;
          newTwoIndex = (newOneIndex + 1) % images.length;
        }
  
        mediaElement.closest('.product-item').querySelectorAll(".product-block__image-dots .product-block__image-dot").forEach( (el, index) => {
          el.classList.remove("product-block__image-dot--active");
          if(index == newOneIndex){
            el.classList.add("product-block__image-dot--active");
          }
        });
        
        images.forEach((img, index) => {
          if (index === newOneIndex) {
            img.classList.add('product-item__image--one', 'loaded');
            img.classList.remove('hide__slider--image', 'product-item__image--two');
          } else if (index === newTwoIndex) {
            img.classList.add('product-item__image--two', 'loaded');
            img.classList.remove('hide__slider--image', 'product-item__image--one');
          } else {
            img.classList.add('hide__slider--image');
            img.classList.remove('product-item__image--one', 'product-item__image--two', 'loaded');
          }
  
          // Remove lazy load animation class if present
          if (img.classList.contains('animation--lazy-load')) {
            img.classList.remove('animation--lazy-load');
          }
        });
  
        const productItem = mediaElement.closest('.product-item');
        const mouseEnterEvent = new MouseEvent('mouseenter', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        productItem.dispatchEvent(mouseEnterEvent);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  window.applySlider();
});
